<template>
  <div :id="uuid" :style="{width:width+'px',height:height+'px'}"/>
</template>

<script setup>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty} from "@/utils/refresh-cpt-data";
import {onMounted, watch, computed} from "vue";
import * as echarts from 'echarts'

const props = defineProps({
  width:Number,
  height:Number,
  option:Object,
  show:Boolean,
  components:Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
watch(() => props.option.attribute, (obj) => {
    if(obj.dataZoom && obj.dataZoom.show) {
      obj.grid.y2 = obj.grid.y2 == 30 ? 50 : obj.grid.y2;
    } else {
      obj.grid.y2 = obj.grid.y2 == 50 && obj.grid.y2 != 30 ? 30 : obj.grid.y2;
    }
     processData(props.option.cptDataForm,newData,jsFunFlag)
  loadChart(obj);
},{deep:true})
watch(() => [props.width,props.height], () => {
  chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(()=>{
  chart = echarts.init(document.getElementById(uuid))
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm,paras) {
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm,paras),
  props.components)
}
function loadData(cptDataForm,paras) {
  getDataJson(cptDataForm,paras,(res)=> {
        // cptData = res;
          newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
          jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
          processData(cptDataForm,newData,jsFunFlag)
        loadChart(props.option.attribute);

      })
}
function processData(cptDataForm,res,jsFunFlag){
          // 第一层判断 如果选择数据集
          if(cptDataForm.dataSource == '4') {
            // 第二层判断 ，如果没有配转换脚本
            if(jsFunFlag) { // 没有全部配置映射字段
                if(hasNonEmptyValues(props.option.attribute.cptTableData)) {
                    const dataKey = props.option.attribute.cptTableData;
                    let newarr = [];
                    console.log(res,'resresres');
                    res.forEach(item => {
                      let group = item[dataKey[0].value];
                      let dimension = item[dataKey[1].value];
                      let indicator = item[dataKey[2].value];

                      // 查找或创建对应的分组对象
                      let groupItem = newarr.find(groupObj => groupObj.name === group);
                      if (!groupItem) {
                      groupItem = { name: group, data: [] };
                      newarr.push(groupItem);
                      }
                     // 在对应分组的数据数组中添加维度和指标
                      groupItem.data.push({ name: dimension, value: indicator });
                   });
                   console.log(newarr,'新数组')
                   cptData = newarr; 
              }
             } else { // 如果配置了转换脚本
                cptData = res;
             }
          } else { // 不是数据集类型，是静态数据
               cptData = res;
          } 
    }
function loadChart(attribute) {
  let attr = JSON.parse(JSON.stringify(attribute))//watch循环修复，xAxis指向的对象被更改影响
  chartOption = {
    color:attr.color,
    tooltip: attr.tooltip,
    // {
    //   trigger: 'axis',
    //   axisPointer: {type: 'shadow'}
    // },
    title:attr.title,
    xAxis:attr.xAxis,
    yAxis:attr.yAxis,
    legend: attr.legend,
    grid: attr.grid,
    series: [],
    dataZoom:attr.dataZoom,
  }
  let axisData = [];
 cptData[0].data.forEach(item => {
    axisData.push(item.name)
  })
  let xAxisType = 'category';
  let yAxisType= 'value';
  if(attr.direction === 'y'){
    xAxisType = 'value';
    yAxisType ='category';
  }
  chartOption.xAxis.type = xAxisType
  chartOption.yAxis.type = yAxisType
  chartOption.xAxis.data = axisData
  chartOption.yAxis.data = axisData

  let totalArr = []
  if(attr.enablePa === '1'){//开启百分比----先计算总数
    for (let i = 0; i < cptData.length; i++) {
      const item = cptData[i]
      item.data.forEach(li => {
        if(!totalArr[axisData.indexOf(li.name)]){
          totalArr[axisData.indexOf(li.name)] = 0;
        }
        totalArr[axisData.indexOf(li.name)] += li.value
      })
    }
  }

  for (let i = 0; i < cptData.length; i++) {
    const item = cptData[i]
    let data = []
    if(attr.enablePa === '1'){//开启百分比
      for (let j = 0; j < item.data.length; j++) {
        const li = item.data[j]
        const index = axisData.indexOf(li.name);
        // data[index] = [j,(li.value/totalArr[index]*100).toFixed(2),li.value]
        data[index] = (li.value/totalArr[index]*100).toFixed(2)
      }
    }else{
      item.data.forEach(li => {
        data[axisData.indexOf(li.name)] = li.value
      })
    }

    chartOption.series.push({
      name: item.name,
      type: 'bar',
      stack: 'total',
      label: {
        show: attr.series.label.show,
        fontSize: attr.series.label.fontSize,
        color: attr.series.label.color,
        position: 'top',
        // formatter: function(params) {
        //   // 只在最后一个柱子显示
        //   return params.dataIndex === 2 ? params.value : '';
        // }
      },
      emphasis: {
        focus: 'series'
      },
      barWidth: attr.series.barWidth,
      data: data
    })
  }
  // 显示堆叠合计
  if(attr.series.label?.stackShow) {
    for (let i = 0; i < chartOption.series.length; i++) {
      const seriesItem = chartOption.series[i];
      if(chartOption.series.length - 1 == i) {
      console.log(chartOption.series.length -1 , i ,seriesItem,chartOption,'qwdijqiwdjiqdijqd');

        seriesItem.label.formatter = function(params) {
          // 计算当前柱子的总和
          const total = chartOption.series.map(item => {
            // item.data = item.data.map((num,index) => {
            //   return num || 0
            // })
            let data = []
            for (let i = 0; i < item.data.length; i++) {
              const itemData = item.data[i];
              data.push(itemData || 0)
            }
            item.data = data
            return item
          })
          .reduce((sum, s) => {
            return sum + (s.data[params.dataIndex] || 0)
          }, 0);
          return total.toFixed(attr.series.label?.fixed || 2);
        }
      } else {
        seriesItem.label.formatter = function(params) {
          // 计算当前柱子的总和
          
          return '';
        }
      }
      
    }
  }
 

 
    // seriesItem.label.formatter =  function(params) {
    //     console.log(chartOption,chartOption.series[params.seriesIndex],chartOption.series[params.seriesIndex].name,params.seriesIndex, params.dataIndex,'iqjwdiqwdij')
    //     console.log(chartOption.series[params.seriesIndex].data.length , params.dataIndex,'kqwodoqwodko')
    //     if((chartOption.series[params.seriesIndex].data.length - 1) == params.dataIndex) {
    //       console.log(chartOption.series[params.seriesIndex].name, params.dataIndex,'1o2o1jid1ijd')
    //       return 2
    //     } else { 
    //       return ''
    //     }
    // }
    
  // }
  console.log(chartOption.series,'asdkoasdoasodk')
  chart.setOption(chartOption,true);
  chart.on('click', (params) => {
    emit("clickHandler",props.option.interaction,'default',params.name)
  })
}
defineExpose({refreshCptData})
</script>

<style scoped>

</style>
